<ol class="breadcrumb">
  @if (!(breadcrumbs$ | async)) {
    <li><a>Home</a></li>
  }

  @for (breadcrumb of (breadcrumbs$ | async); track breadcrumb) {
    <li>
      <a [routerLink]="breadcrumb.url" [class.disabled]="breadcrumb.disabled">
        {{ breadcrumb.label }}
      </a>
    </li>
  }
</ol>